/**
 * KERIS map — matching Lovable RetailerMap interactions and UI.
 */
(function () {
  'use strict';

  /* Fallback si le JSON Liquid est absent — aligné sur la home (24 partenaires). */
  var DEFAULT_PARTNERS = [
    { name: "PISA", address: "Milano, Italy", lat: 45.4661254, lng: 9.1858801, website: "https://pisa1940.com/" },
    { name: "FIIFAA", address: "Lagos, Nigeria", lat: 6.5244, lng: 3.3792, website: "https://fiifaa.com/shop/" },
    { name: "Burdeen's Jewelry", address: "Chicago, USA", lat: 41.8781, lng: -87.6298 },
    { name: "TIME+TIDE Watches UK", address: "London, United Kingdom", lat: 51.5159011, lng: -0.1403928, website: "https://timeandtidewatches.com/" },
    { name: "Chronopassion", address: "Paris, France", lat: 48.8677953, lng: 2.324762 },
    { name: "Manfredi Jewels", address: "Greenwich, USA", lat: 41.029048, lng: -73.6260408 },
    { name: "Manfredi Jewels", address: "Westport, USA", lat: 41.1466313, lng: -73.493603 },
    { name: "Time Keeper", address: "Kuwait City, Kuwait", lat: 29.3615133, lng: 47.9663614 },
    { name: "Ahmed Seddiqi & Sons", address: "Abu Dhabi, UAE", lat: 24.5008472, lng: 54.3880931, website: "https://www.seddiqi.com" },
    { name: "PONCINI Port Louis", address: "Port Louis, Mauritius", lat: -20.1637152, lng: 57.5039423 },
    { name: "Modern Home", address: "Doha, Qatar", lat: 25.285447, lng: 51.53104 },
    { name: "Asia Jewellers", address: "Manama, Bahrain", lat: 26.2389989, lng: 50.5818779 },
    { name: "Bandiera Jewellers", address: "Toronto, Canada", lat: 43.7900216, lng: -79.5470861 },
    { name: "Judith Norman", address: "Hollywood, FL, USA", lat: 26.0410113, lng: -80.1654932, website: "https://www.judithnorman.com" },
    { name: "Curiosity Store Genève", address: "Geneva, Switzerland", lat: 46.2089749, lng: 6.1467841 },
    { name: "TIME+TIDE Watches AU", address: "Melbourne, Australia", lat: -37.8149785, lng: 144.9676158, website: "https://timeandtidewatches.com/" },
    { name: "Curiosity Store Lausanne", address: "Lausanne, Switzerland", lat: 46.519653, lng: 6.632273 },
    { name: "BEN JANNET", address: "Tunis, Tunisia", lat: 36.806494, lng: 10.181531 },
    { name: "10Ten Labs", address: "Riyadh, Saudi Arabia", lat: 24.7135517, lng: 46.6752957 },
    { name: "Collector's House", address: "Seoul, South Korea", lat: 37.566535, lng: 126.9779692 },
    { name: "Premier Group", address: "Almaty, Kazakhstan", lat: 43.238293, lng: 76.945465 },
    { name: "Salon Kantiem", address: "Istanbul, Turkey", lat: 41.008583, lng: 28.980175 },
    { name: "Casa Barros Echeñique", address: "Santiago, Chile", lat: -33.4489, lng: -70.6693 },
    { name: "TIME+TIDE Watches NYC", address: "New York, USA", lat: 40.7614, lng: -73.9776, website: "https://timeandtidewatches.com/" },
  ];

  function getCountry(address) {
    var parts = String(address || '').split(',');
    return (parts[parts.length - 1] || '').trim();
  }

  /** Icône HTML : avec markerZoomAnimation:false sur la carte, ces points ne subissent pas le scale CSS du zoom. */
  function partnerDivIcon(selected, visible) {
    var dim = selected ? 16 : 12;
    var op = visible ? 1 : 0.12;
    var border = selected ? '2px solid #ffffff' : '2px solid rgba(61,0,163,0.5)';
    var html =
      '<div style="width:24px;height:24px;display:flex;align-items:center;justify-content:center;">' +
      '<span style="display:block;width:' + dim + 'px;height:' + dim + 'px;border-radius:50%;' +
      'background:#3D00A3;border:' + border + ';opacity:' + op + ';box-sizing:border-box;"></span></div>';
    return L.divIcon({
      className: 'keris-map-partner-icon',
      html: html,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12],
    });
  }

  function popupHtml(r) {
    return (
      '<div style="padding:6px 8px;min-width:180px;">' +
        '<p style="font-size:13px;font-weight:600;letter-spacing:.1em;margin:0 0 4px;">' + (r.name || '') + '</p>' +
        '<p style="font-size:11px;color:#888;margin:0 0 10px;">' + (r.address || '') + '</p>' +
        (r.website ? (
          '<a href="' + r.website + '" target="_blank" rel="noopener noreferrer" ' +
            'style="display:inline-block;font-size:11px;letter-spacing:.15em;text-transform:uppercase;font-weight:500;padding:6px 16px;border:1px solid #3D00A3;color:#3D00A3;text-decoration:none;">Visit Website</a>'
        ) : '') +
      '</div>'
    );
  }

  function initOne(root) {
    if (!root || typeof L === 'undefined') return;
    var dataId = root.getAttribute('data-map-data-id');
    var dataEl = dataId ? document.getElementById(dataId) : null;
    var mapEl = root.querySelector('[data-keris-map-canvas]');
    var chipsEl = root.querySelector('[data-keris-map-chips]');
    var listEl = root.querySelector('[data-keris-map-list]');
    var countEl = root.querySelector('[data-keris-map-count]');
    var rightEl = root.querySelector('.keris-rm-right');
    var wrapEl = root.querySelector('.keris-map-wrap');
    if (!mapEl || !chipsEl || !listEl || !countEl) return;

    var partners = [];
    if (dataEl) {
      try {
        partners = JSON.parse(dataEl.textContent || '[]');
      } catch (_e) {}
    }
    if (!Array.isArray(partners) || partners.length < 1) partners = DEFAULT_PARTNERS.slice();

    var selected = null;
    var selectedCountry = null;
    var markers = [];

    var map = L.map(mapEl, {
      center: [25, 15],
      zoom: 2,
      minZoom: 2,
      maxZoom: 14,
      scrollWheelZoom: true,
      zoomControl: true,
      attributionControl: false,
      // Path/canvas/SVG suivent le scale du zoom animé ; les L.Marker+divIcon, non.
      markerZoomAnimation: false,
    });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png').addTo(map);

    function syncHeight() {
      if (!rightEl || !wrapEl) return;
      if (window.matchMedia('(min-width: 1100px)').matches) {
        var head = root.querySelector('.keris-rm__head');
        var list = root.querySelector('.keris-rm__list');
        var h = 0;
        if (head && list) {
          h = Math.ceil(list.getBoundingClientRect().bottom - head.getBoundingClientRect().top);
        }
        if (h < 400) h = 400;
        rightEl.style.height = h + 'px';
        wrapEl.style.height = '100%';
      } else {
        rightEl.style.height = '';
        wrapEl.style.height = '';
      }
      requestAnimationFrame(function () {
        map.invalidateSize({ animate: false });
      });
    }

    partners.forEach(function (r, i) {
      var lat = parseFloat(r.lat);
      var lng = parseFloat(r.lng);
      if (isNaN(lat) || isNaN(lng)) return;
      var marker = L.marker([lat, lng], {
        icon: partnerDivIcon(false, true),
        interactive: true,
      }).addTo(map);
      marker.bindPopup(popupHtml(r), { closeButton: false, className: 'partner-popup' });
      marker.on('click', function () {
        if (selected === i) {
          selected = null;
          render();
          return;
        }
        selected = i;
        var pr = partners[i];
        map.flyTo([parseFloat(pr.lat), parseFloat(pr.lng)], 8, { duration: 1.2 });
        render();
        if (markers[i]) markers[i].openPopup();
      });
      markers.push(marker);
    });

    function countryData() {
      var counts = {};
      partners.forEach(function (p) {
        var c = getCountry(p.address);
        counts[c] = (counts[c] || 0) + 1;
      });
      return Object.keys(counts).sort().map(function (k) { return { name: k, count: counts[k] }; });
    }

    function filtered() {
      return partners.map(function (p, i) {
        var cp = {};
        for (var k in p) cp[k] = p[k];
        cp.originalIndex = i;
        return cp;
      }).filter(function (p) {
        return !selectedCountry || getCountry(p.address) === selectedCountry;
      });
    }

    function renderChips() {
      var all = countryData();
      var html = '<button class="keris-rm__chip ' + (!selectedCountry ? 'is-active' : '') + '" data-country="">All · ' + partners.length + '</button>';
      all.forEach(function (c) {
        html += '<button class="keris-rm__chip ' + (selectedCountry === c.name ? 'is-active' : '') + '" data-country="' +
          c.name.replace(/"/g, '&quot;') + '">' + c.name + ' · ' + c.count + '</button>';
      });
      chipsEl.innerHTML = html;
      chipsEl.querySelectorAll('[data-country]').forEach(function (b) {
        b.addEventListener('click', function () {
          var c = b.getAttribute('data-country');
          selectedCountry = c || null;
          selected = null;
          render();
        });
      });
    }

    function focusRetailer(idx) {
      var r = partners[idx];
      selected = idx;
      map.flyTo([parseFloat(r.lat), parseFloat(r.lng)], 8, { duration: 1.2 });
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      render();
      if (markers[idx]) markers[idx].openPopup();
    }

    function renderList() {
      var fp = filtered();
      countEl.textContent = fp.length + ' partner' + (fp.length > 1 ? 's' : '') + (selectedCountry ? (' in ' + selectedCountry) : ' worldwide');
      listEl.innerHTML = fp.map(function (r) {
        return '<button type="button" class="keris-rm__item ' + (selected === r.originalIndex ? 'is-active' : '') + '" data-idx="' + r.originalIndex + '">' +
          '<span class="keris-rm__item-title">' + r.name + '</span>' +
          '<span class="keris-rm__item-address">' + r.address + '</span>' +
        '</button>';
      }).join('');
      listEl.querySelectorAll('[data-idx]').forEach(function (b) {
        b.addEventListener('click', function () {
          focusRetailer(parseInt(b.getAttribute('data-idx'), 10));
        });
      });
    }

    function renderMarkers() {
      var visibleBounds = [];
      markers.forEach(function (m, i) {
        var visible = !selectedCountry || getCountry(partners[i].address) === selectedCountry;
        m.setIcon(partnerDivIcon(selected === i, visible));
        if (selected === i) {
          m.setZIndexOffset(1000);
        } else {
          m.setZIndexOffset(0);
        }
        if (visible) visibleBounds.push([parseFloat(partners[i].lat), parseFloat(partners[i].lng)]);
      });
      // Un revendeur précis est sélectionné : la carte est pilotée par focusRetailer ou le clic marqueur.
      if (selected !== null) {
        return;
      }
      if (selectedCountry && visibleBounds.length) {
        map.flyToBounds(L.latLngBounds(visibleBounds), { padding: [60, 60], duration: 1, maxZoom: 6 });
      } else if (!selectedCountry) {
        map.flyTo([25, 15], 2, { duration: 1 });
      }
    }

    function render() {
      renderChips();
      renderList();
      renderMarkers();
      syncHeight();
    }

    render();
    window.addEventListener('resize', syncHeight);
    setTimeout(syncHeight, 50);
    setTimeout(syncHeight, 300);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncHeight();
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-keris-map-root]');
    roots.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
